import { render, staticRenderFns } from "./payment-breakdown.vue?vue&type=template&id=10ac7ba3&"
import script from "./payment-breakdown.vue?vue&type=script&lang=js&"
export * from "./payment-breakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports